var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('audio',{attrs:{"id":"audio1"}},[_c('source',{attrs:{"src":"/audio/1.mp3"}})]),_c('audio',{attrs:{"id":"audio2"}},[_c('source',{attrs:{"src":"/audio/2.mp3"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }